import React, { Component } from 'react';
import {Helmet} from "react-helmet";

import AppBar from 'material-ui/AppBar';
import { Step, Stepper, StepLabel } from 'material-ui/Stepper';

import CustomerDetails from './components/form/CustomerDetails';
import CarDetails from './components/form/CarDetails';
import WashDetails from './components/form/WashDetails';
import CardDetails from './components/form/CardDetails';
import Confirm from './components/form/Confirm';
import ConfirmAndPay from './components/form/ConfirmAndPay';

import Details from './components/form/Details';

import request from 'request-promise';

import Config from './conf';
import Util from './Util';

import 'whatwg-fetch';

const STEPS = Config.BOOKING_STEPS;

class Home extends Component {

  constructor(props) {
    super(props);

    this.next = this.next.bind(this);
    this.back = this.back.bind(this);
    this.updateField = this.updateField.bind(this);
    this.setFpMember = this.setFpMember.bind(this);
    this.setCarType = this.setCarType.bind(this);
    this.setHasError = this.setHasError.bind(this);
    this.setLoading = this.setLoading.bind(this);

    this.updateDimensions = this.updateDimensions.bind(this);
    this.getTempToken = this.getTempToken.bind(this);

    this.state = {
      step: 0,
      name: '',
      nameError: false,
      phone: '',
      phoneError: false,
      company: '',
      companyError: false,
      email: '',
      emailError: '',
      address: '',
      postcode: 2010, // hardcoded as we dont do any geocoding at the moment
      addressError: false,
      numberPlate: '',
      numberPlateError: false,
      date: null,
      dateError: false,
      time: '',
      startTime: '',
      endTime: '',
      timeError: false,
      carType: 'Sedan',
      washType: null,
      washPrice: 0,
      fpMember: null,

      washDetails: null,

      isLoading: false,
      isSmallScreen: false,

      cvc: false,
      cardNumber: false,
      expiry: false,

      stripe: null,
      stripeToken: null,
      cardId: null,

      stripeMessage: '',
      stripeError: false,

      carParkLevel: '',
      carParkSpot: '',
    };

    // Get wash details
    let washDetails;
    const options = {
      uri: Config.BACKEND_API_URL + 'booking/washes-details',
      qs: { cid: Config.CLIENT_ID },
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      json: true
    };

    request(options).then((response) => {

      Object.keys(response.result).forEach((wash) => {
        switch (wash) {
          case 'OUTIE':
            response.result[wash].orginalPrice = 29;
            return;
          case 'FULLO':
            response.result[wash].orginalPrice = 69;
            return;
        }
      });
      washDetails = response.result;
    }).catch((err) => {
      console.log('Failed to get wash details',err);
    }).then(() => {
      this.setState({washDetails});
    });
  }

  next() {
    this.setState((prevState, props) => {
      return {
        step: prevState.step + 1
      };
    });
  }

  back() {
    this.setState((prevState, props) => {
      return {
        step: prevState.step - 1
      };
    });
  }

  getTempToken() {
    return Util.backendGet('account/temp-token', null).then((json) => {
      if (json.result === 'success') {
        localStorage.setItem('token', json.token);
      }
    });
  }

  updateField(fieldName, fieldValue, callback) {
    const detailsObj = {};
    detailsObj[fieldName] = fieldValue;
    this.setState(detailsObj, callback);
  }

  setHasError(fieldName, hasError) {
    const detailsObj = {};
    detailsObj[fieldName + 'Error'] = hasError;
    this.setState(detailsObj);
  }

  setFpMember(val) {
    this.updateField('fpMember', val);
  }

  setCarType(evt, idx, val) {
    this.updateField('carType', val, () => {
      let extraWashPrice = 0;
      if (this.state.carType.toUpperCase() === 'SUV') {
        extraWashPrice = 10;
      } else if (this.state.carType.toUpperCase() === 'VAN') {
        extraWashPrice = 20;
      }
      if (this.state.washType) {
        this.updateField('washPrice', this.state.washDetails[this.state.washType].cost + (extraWashPrice));
      }
    });
  }

  setLoading(loading) {
    this.setState({
      isLoading: loading
    });
  }

  updateDimensions() {
    const width = window.innerWidth;
    const small = width < 768;
    this.setState({
      isSmallScreen: small
    });
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions);
    this.updateDimensions();
    this.getTempToken();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  render() {
    const style = {
      container: {
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        marginLeft: this.state.isSmallScreen ? '10%' : '20%',
        marginRight: this.state.isSmallScreen ? '10%' : '20%'
      },
      gap: {
        marginTop: '3vh'
      },
      navbar: {
        height: 120,
      },
      navbarInner: {
        height: 120,
        marginTop: 0,
        textAlign: 'center'
      },
      imageLogo: {
        marginTop: 8,
        height: 100,
        width: 'auto',
        maxWidth: 800
      },
      imageLocalLogo: {
        marginTop: 8,
        height: 100,
        width: 'auto',
        maxWidth: 200
      },
      mainlogo: {
        backgroundImage: 'url("' + Config.LOGO_PATH + '")',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'right',
        width: '100%',
        maxWidth: '50%',
        backgroundSize: 'contain',
        display: 'inline-block'
      },
      locallogo: {
        backgroundImage: 'url("' + Config.LOCAL_LOGO_PATH + '")',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'left',
        width: '100%',
        maxWidth: '50%',
        backgroundSize: 'contain',
        display: 'inline-block'
      }
    };

    // Use custom navbar colour for McCarrolls
    if (Config.CLIENT_NAME !== 'McCarrolls') style.navbar['backgroundColor'] = '#fff';

    return (
      <div>
        <Helmet>
          <title>{Config.PAGE_TITLE}</title>
          <link rel="shortcut icon" href={Config.FAVICON_PATH} />

        </Helmet>
        <AppBar
          title={
            <div>
              <div alt="logo" style={{ ...style.imageLogo, ...style.mainlogo }} ></div>
              {Config.LOCAL_LOGO_PATH &&
                <div src={Config.LOCAL_LOGO_PATH} alt="local logo" style={{ ...style.imageLocalLogo, ...style.locallogo }} ></div>
              }
            </div>
          }
          style={style.navbar}
          titleStyle={style.navbarInner}
          showMenuIconButton={false}
        />

        <div style={style.gap} />

        <div style={style.container}>
          {!this.state.isSmallScreen && Config.PAYMENT_TYPE === "PRE" &&
            <Stepper activeStep={this.state.step}>
              <Step style={style.step}>
                <StepLabel>Car Details</StepLabel>
              </Step>
              <Step style={style.step}>
                <StepLabel>Wash Details</StepLabel>
              </Step>
              <Step style={style.step}>
                <StepLabel>Your Details</StepLabel>
              </Step>
              <Step style={style.step}>
                <StepLabel>Payment Details</StepLabel>
              </Step>
              <Step style={style.step}>
                <StepLabel>Finished</StepLabel>
              </Step>
            </Stepper>
          }

          {STEPS[this.state.step] === 'carDetails' &&
            <CarDetails
              next={this.next}
              details={this.state}
              updateField={this.updateField}
              setHasError={this.setHasError}
              setCarType={this.setCarType}
            />
          }
          {STEPS[this.state.step] === 'washDetails' &&
            <WashDetails
              updateField={this.updateField}
              setHasError={this.setHasError}
              details={this.state}
              next={this.next}
              back={this.back}
            />
          }
          {STEPS[this.state.step] === 'preCustomerDetails' &&
            <CustomerDetails
              next={this.next}
              back={this.back}
              details={this.state}
              updateField={this.updateField}
              setHasError={this.setHasError}
              setFpMember={this.setFpMember}
            />
          }
          {STEPS[this.state.step] === 'creditcard' &&
            <CardDetails
              next={this.next}
              back={this.back}
              details={this.state}
              updateField={this.updateField}
              setHasError={this.setHasError}
            />
          }
          {STEPS[this.state.step] === 'preFinished' &&
            <ConfirmAndPay
              back={this.back}
              next={this.next}
              updateField={this.updateField}
              details={this.state}
            />
          }

          {STEPS[this.state.step] === 'postCustomerDetails' &&
          <Details
            next={this.next}
            details={this.state}
            updateField={this.updateField}
            setHasError={this.setHasError}
            setCarType={this.setCarType}
          />
          }
          {STEPS[this.state.step] === 'postFinished' &&
          <Confirm
            back={this.back}
            next={this.next}
            details={this.state}
          />
          }


        </div>

        <div id="footer">
          <div id="footerText">
            Powered by <a target="_blank" href="https://www.wipehero.com.au/">WipeHero</a> &copy; 2018
          </div>
        </div>
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/app/Home.js